<template>
    <DocsPageLayout
        title="Welcome to Docs"
        subtitle="Learn what MyStekz is and how this documentation is organized."
        :nav-links="navLinks"
        :nav-groups="navGroups"
        :toc-items="tocItems"
        active-nav-to="/docs"
    >
        <Card id="about-mystekz" class="content-card introduction">
            <template #title>
                <h2>About MyStekz</h2>
            </template>
            <template #content>
                <p>
                    MyStekz is the platform for the superintelligent business.
                    It captures the model of your business — domains, products,
                    processes, roles, and execution data — in one connected
                    place, so people and AI agents can design, build, launch,
                    and operate it together.
                </p>
            </template>
        </Card>

        <Card id="about-docs" class="content-card">
            <template #title>
                <h2>About This Documentation</h2>
            </template>
            <template #content>
                <p>
                    This docs space is structured by sections so new guides can
                    be added over time. Start with foundational API docs, then
                    move into integrations and operations as your setup grows.
                </p>
            </template>
        </Card>
    </DocsPageLayout>
</template>

<script setup lang="ts">
import Card from "primevue/card";

import DocsPageLayout from "@/components/docs/DocsPageLayout.vue";

const navLinks = [{ label: "Welcome to Docs", to: "/docs" }];

const navGroups = [
    {
        label: "Core",
        open: true,
        items: [{ label: "Live Events", to: "/docs/core/live-mode-events" }],
    },
];

const tocItems = [
    { id: "about-mystekz", label: "About MyStekz" },
    { id: "about-docs", label: "About This Documentation" },
];
</script>
